module.exports = __webpack_public_path__ + "img/trade_univertrade.0375cc6.png";